import React, { useState, useEffect } from 'react';
import '../../css/spendInsurance.css';
import { Link, useNavigate } from 'react-router-dom';
import { useMobileMediaQuery, useTabletMediaQuery, currencyFormat, formatEuroAmount, formatIbanPT } from '../../utils';
import { useDispatch, useSelector } from 'react-redux';
import { setStartSpend, setCookieId, setSessionId, setAssociatedInsuraceList, setRefreshConsultaDeducoes, setRefreshGastarSaldo } from '../../features/onboardingData/onboardingUserData';
import ListDeduction from './ListDeduction';
import CustomButton from "../CustomButton";
import { IoIosArrowDown, IoMdClose } from "react-icons/io";
import { AiOutlineStop } from "react-icons/ai";
import { FaArrowLeftLong, FaArrowRightLong } from "react-icons/fa6";
import IconMinusSvg from '../../assets/svg/iconMinus.svg'
import IconPlusSvg from '../../assets/svg/iconPlus.svg'
import IconAddCard from '../../assets/svg/iconAddCardPartnersDetails.svg';
import IconGetPercentage from '../../assets/svg/iconGetPercentagePartnersDetails.svg';
import IconSpendBalance from '../../assets/svg/iconGanharSaldo.svg';
import moment from 'moment';
import 'moment/locale/pt';
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import { errorHandling } from '../../utils';
import { useMsal } from '@azure/msal-react';
import { InteractionRequiredAuthError, InteractionStatus } from "@azure/msal-browser";
import { msalInstance } from '../..';
import { toast } from "react-toastify";
import EmptyInsuranceList from './EmptyInsuranceList';
import GifAnim from '../../components/GifAnim';

function SpendInsurance() {

    const isMobile = useMobileMediaQuery();
    const isTablet = useTabletMediaQuery();
    const navigate = useNavigate();
    const { instance, inProgress, accounts } = useMsal();
    let valor = 0;
    const [isStartingLoadingAnim, setIsStartingLoadingAnim] = useState(false)
    const [isStartingLoadingDots, setIsStartingLoadingDots] = useState(false)
    const [isSelectedValue5, setSelectedValue5] = useState(false);
    const [isSelectedValue10, setSelectedValue10] = useState(false);
    const [isSelectedValue20, setSelectedValue20] = useState(false);
    const [value, setValor] = useState('0,00');
    const [isCardNumber, setIsCardNumber] = useState(false);
    const [iban, setIban] = useState('');
    const [errorMsgIban, setErrorMsgIban] = useState('');
    const [errorMsgValue, setErrorMsgValue] = useState('');
    const [selectOptions, setSelectOptions] = useState('');
    const [selectOptionsReceiptNumber, setSelectOptionsReceiptNumber] = useState('');
    const [selectOptionsCardNumber, setSelectOptionsCardNumber] = useState('');
    const [selectedOptionsAmount, setSelectedOptionsAmount] = useState(0);
    const [selectedOptionsDate, setSelectedOptionsDate] = useState([]);
    const [selectOptionsList, setSelectOptionsList] = useState([]);
    const hasEmptyReceiptNumber = selectOptionsList?.every(item => item.receiptNumber == '');
    const [isDeduction, setIsDeduction] = useState(false);
    const isSessionId = useSelector((state) => state.onboardingUserData.isSessionId);
    const isCookieId = useSelector((state) => state.onboardingUserData.isCookieId);
    const isSaldoCarteira = useSelector((state) => state.onboardingUserData.isSaldoCarteira);
    const isStatusCarteira = useSelector((state) => state.onboardingUserData.isStatusCarteira);
    const isStartSpend = useSelector((state) => state.onboardingUserData.isStartSpend);
    const isAssociatedInsuraceList = useSelector((state) => state.onboardingUserData.isAssociatedInsuraceList);
    const isRefreshConsultaDeducoes = useSelector((state) => state.onboardingUserData.isRefreshConsultaDeducoes);
    const isRefreshGastarSaldo = useSelector((state) => state.onboardingUserData.isRefreshGastarSaldo);
    const dispatch = useDispatch();
    const [inputAmountFocus, setInputAmountFocus] = useState(false);
    const [inputFocus, setInputFocus] = useState(false);
    const [selectedOption, setSelectedOption] = useState(false);
    const [swiperIndexOne, setSwiperIndexOne] = useState(0);
    const [swiperInstanceOne, setSwiperInstanceOne] = useState(null);
    const [isInsuraceToken, setInsuraceToken] = useState('');
    const [showApolice, setShowApolice] = useState(false);
    const handleCloseApolice = () => setShowApolice(false);
    const handleShoweApolice = () => setShowApolice(true);
    const [filteredApolices, setFilteredApolices] = useState([]);
    const [pageNumber, setPageNumber] = useState(1);
    const [numeroDePaginas, setNumeroDePaginas] = useState(0);
    const [deducoesList, setDeducoesList] = useState([]);

    const handleLogout = async () => {
        try {
            localStorage.clear();
            const response = await instance.logout();
        }
        catch (error) {
            errorHandling();
        }
    };

    const accessTokenRequestInsurance = () => {
        if (inProgress === InteractionStatus.None) {
            setIsStartingLoadingAnim(true);
            const accessTokenRequest = {
                scopes: [process.env.REACT_APP_INSURANCE_READ],
                account: accounts[0],
            };
            instance
                .acquireTokenSilent(accessTokenRequest)
                .then((accessTokenResponse) => {
                    // Acquire token silent success
                    let accessToken = accessTokenResponse.accessToken;
                    setInsuraceToken(accessToken)
                    if (process.env.REACT_APP_CONSOLE_LOG !== "N") {
                        console.log("Insurance Response: " + accessToken);
                    }
                })
                .catch((error) => {
                    setIsStartingLoadingAnim(false);
                    if (error instanceof InteractionRequiredAuthError) {
                        const loginRequest = {
                            scopes: ["openid"],
                        };
                        msalInstance.loginRedirect(loginRequest);
                    }
                    handleLogout();
                }
                );
        }
    }

    const getAssociatedInsuraceList = async () => {
        try {
            setIsStartingLoadingAnim(true);
            const response = await fetch(`${process.env.REACT_APP_DEV_URL}/getAssociatedInsuraceList/fetchGetAssociatedInsuraceList`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': 'PT-PT',
                    'CookieId': `${isCookieId}`,
                    'SessionId': `${isSessionId}`,
                    'bToken': `${isInsuraceToken}`,
                },
            });
            if (response.ok === false) {
                errorHandling(response.status);
                return;
            }
            const result = await response.json();
            if (result.error.erroMsg === 'Success') {
                setSelectOptionsList(result.listaSeguros)
                setFilteredApolices(result.listaSeguros)
            } else {
                setSelectOptionsList(result?.listaSeguros)
                setFilteredApolices(result?.listaSeguros)
            }
        } catch (error) {
            if (!navigator.onLine) {
                errorHandling('NoInternet');
            } else if (error instanceof TypeError && error.message === "Failed to fetch") {
                errorHandling('CORS');
            } else {
                errorHandling();
            }
        } finally {
            setIsStartingLoadingAnim(false);
        }
    }

    useEffect(() => {
        accessTokenRequestInsurance();
    }, []);

    useEffect(() => {
        if (selectOptionsList.length > 0) {
            getConsultaDeducoes();
        }
    }, [pageNumber, selectOptionsList]);

    useEffect(() => {
        if (isRefreshConsultaDeducoes) {
            getConsultaDeducoes();
        }
    }, [isRefreshConsultaDeducoes]);

    useEffect(() => {
        if (isInsuraceToken !== '') {
            getAssociatedInsuraceList();
        }
    }, [isInsuraceToken]);

    const fetchCSRFToken = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_DEV_URL}/csrf-token`, {
                credentials: "include",
                mode: 'cors'
            });
            const data = await response.json();
            const csrfToken = data.csrfToken;

            return csrfToken;
        } catch (error) {
            errorHandling('CSRF');
        }
    };

    const postValidatePremiumDeduction = async () => {
        setIsStartingLoadingDots(true);
        try {
            const csrfToken = await fetchCSRFToken();
            const response = await fetch(`${process.env.REACT_APP_DEV_URL}/validatePremiumDeduction/fetchValidatePremiumDeduction`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': 'PT-PT',
                    'CookieId': `${isCookieId}`,
                    'SessionId': `${isSessionId}`,
                    "xsrf-token": csrfToken,
                },
                credentials: "include",
                mode: "cors",
                body: JSON.stringify({
                    policyNumber: selectOptions,
                    deductionValue: value.toString(),
                    nib: iban.replace(/\s+/g, '').slice(4),
                    receiptNumber: selectOptionsReceiptNumber
                }),
            });
            if (response.ok === false) {
                errorHandling(response.status);
                return;
            }
            const result = await response.json();
            if (result.erroMsg === 'Success') {
                setIsStartingLoadingDots(false);
                hadleBtnClickGoTo();
            } else {
                setIsStartingLoadingDots(false);

                const nibError = result?.errorStatus?.find(
                    e => e.fieldName === 'nib'
                );
                const valueError = result?.errorStatus?.find(
                    e => e.fieldName === 'deductionValue'
                );

                setErrorMsgIban(nibError?.erroMsg || '');
                setErrorMsgValue(valueError?.erroMsg || '');
            }
        } catch (error) {
            setIsStartingLoadingDots(false);
            if (!navigator.onLine) {
                errorHandling('NoInternet');
            } else if (error instanceof TypeError && error.message === "Failed to fetch") {
                errorHandling('CORS');
            } else {
                errorHandling();
            }
        } finally {
            setIsStartingLoadingDots(false);
        }
    }

    const getConsultaDeducoes = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_DEV_URL}/consultaDeducoes/fetchConsultaDeducoes`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': 'PT-PT',
                    'CookieId': `${isCookieId}`,
                    'SessionId': `${isSessionId}`,
                    'pagina': pageNumber,
                },
            });
            if (response.ok === false) {
                errorHandling(response.status);
                return;
            }
            const result = await response.json();
            if (result.error.erroMsg === 'Success') {
                if (result.deducoes?.length > 0) {
                    setIsDeduction(true);
                }
                setDeducoesList(result.deducoes);
                setNumeroDePaginas(result.numPaginas);
                dispatch(setRefreshConsultaDeducoes(false));
                dispatch(setRefreshGastarSaldo(!isRefreshGastarSaldo));
            }
        } catch (error) {
            if (!navigator.onLine) {
                errorHandling('NoInternet');
            } else if (error instanceof TypeError && error.message === "Failed to fetch") {
                errorHandling('CORS');
            } else {
                errorHandling();
            }
        }
    }

    const nextImageOne = () => {
        if (swiperInstanceOne !== null) {
            swiperInstanceOne.slideNext();
        }
    };

    const prevImageOne = () => {
        if (swiperInstanceOne !== null) {
            swiperInstanceOne.slidePrev();
        }
    };

    const handleSwiperSlideChangeOne = (swiperOne) => {
        setSwiperIndexOne(swiperOne.activeIndex);
    };

    const tiraValor = () => {
        const clean = value.replace(/[^\d]/g, '');
        const amount = parseInt(clean, 10);

        if (amount > 0) {
            const newAmount = Math.max(amount - 100, 0);
            setValor(formatEuroAmount(newAmount / 100));
        }
    };


    const setQuickValue5 = () => {
        if (isCardNumber) {
            setValor(formatEuroAmount(5));
            setSelectedValue5(true);
        }
    };

    const setQuickValue10 = () => {
        if (isCardNumber) {
            setValor(formatEuroAmount(10));
            setSelectedValue10(true);
        }
    };

    const setQuickValue20 = () => {
        if (isCardNumber) {
            setValor(formatEuroAmount(20));
            setSelectedValue20(true);
        }
    };

    const meteValor = () => {
        const clean = value.replace(/[^\d]/g, '');
        const amount = parseInt(clean, 10) + 100;
        setValor(formatEuroAmount(amount / 100));
    };

    const handleAmountChange = (event) => {
        let raw = event.target.value.replace(/[^\d]/g, '');
        if (raw.length < 3) raw = raw.padStart(3, '0');

        const euros = raw.slice(0, -2);
        const cents = raw.slice(-2);
        const formatted = `${parseInt(euros, 10)},${cents}`;

        setValor(formatted);
    };

    const handleFocusAmount = () => {
        setInputAmountFocus(true);
    }

    const handleBlurAmount = () => {
        setInputAmountFocus(false);;
    }

    const handleIbanChange = (event) => {
        let value = event.target.value.toUpperCase();
        const formatted = formatIbanPT(value);
        setIban(formatted);
    };

    const handleFocus = () => {
        setInputFocus(true);
    }

    const handleBlur = () => {
        const delay = setTimeout(() => {
            setInputFocus(false);;
        }, 500);
        return () => clearTimeout(delay);
    }

    const handleDropDown = () => {
        setInputFocus(!inputFocus);
    }

    /* const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            event.target.blur();
            setInputFocus(false);
        }
    }; */

    const hadleBtnClickGoTo = () => {
        const insuranceData = {
            policyNumber: selectOptions,
            amount: value,
            dueDate: selectedOptionsDate,
            nib: iban,
            receiptNumber: selectOptionsReceiptNumber,
            cardNumber: selectOptionsCardNumber
        };
        dispatch(setAssociatedInsuraceList(insuranceData))
        dispatch(setStartSpend(true));
    };

    const handleSeacrhReason = (item) => {
        let policyNumber = item.policyNumber
        let amount = item.amount
        let dueDate = item.dueDate
        let receiptNumber = item.receiptNumber
        let cardNumber = item.cardNumber
        setSelectOptions(policyNumber);
        setSelectedOptionsAmount(currencyFormat(amount));
        setSelectedOptionsDate(dueDate);
        setSelectOptionsReceiptNumber(receiptNumber);
        setSelectOptionsCardNumber(cardNumber);
        setInputFocus(false);
        setIsCardNumber(true);
        setSelectedOption(true);
    }

    const hadleBtnBoxGoPartnersList = () => {
        navigate('/ganhar-saldo/parceiros/catalogo-de-parceiros');
    };

    const hadleBtnBoxGoAssociatedInsurance = () => {
        window.open('https://minhamedis-saude360.medis.pt/UmbrellaApplication_FE/AssociarSeguros', '_blank');
    };

    const hadleBtnBoxGoFAQ = () => {
        window.open('https://saude360.medis.pt/apoio-ao-cliente/', '_blank');
    };

    const highlightMatchedText = (text, query) => {
        if (!query) return text;

        const regex = new RegExp(`(${query})`, 'gi');
        const parts = text.split(regex);

        return parts.map((part, index) =>
            regex.test(part) ? (
                <span key={index} className="highlightPartnersPage">{part}</span>
            ) : (
                part
            )
        );
    };

    const handleInputSeacrhForApolice = (event) => {
        const newValue = event.target.value;
        setSelectOptionsCardNumber(newValue);
        setSelectedOption(false)
        if (newValue.length > 0) {
            //setSelectedSeacrhForNamePartner(false);
            const filtered = selectOptionsList?.filter(item =>
                item.cardNumber.toLowerCase().includes(newValue.toLowerCase())
            );
            setFilteredApolices(filtered);
        }
        else {
            setFilteredApolices(selectOptionsList);
        }
    };

    let inputErrorAmount = (parseFloat(value.replace(',', '.')) > parseFloat(selectedOptionsAmount.toString().replace(',', '.')) || parseFloat(value.replace(',', '.')) > parseFloat(isSaldoCarteira.replace(',', '.')))
    const deductionValueContainer = ((isCardNumber && selectOptionsReceiptNumber != '' && parseFloat(isSaldoCarteira.replace(',', '.')) > 0) ? ((inputErrorAmount || errorMsgValue !== '') ? "deduction-value-error" : "deduction-value") : "deduction-valueDisable")

    return (
        <>
            {(!isTablet && selectOptionsList.length > 0 && !hasEmptyReceiptNumber) && (
                <div className={isMobile ? 'apoliceContainerTablet' : 'apoliceContainerMobile'}>
                    <div className='pTextApolice'>O seu seguro</div>
                    <div className="apoliceCenter">
                        {showApolice ?
                            <div className='btnCloseViewPolicyOffcanvasApolicerSpend'>
                                <div className='txtPolicyNumOffcanvasApolicerSpend'>{selectOptionsCardNumber}</div>
                                <button
                                    className='btnCloseIconOffcanvasApolicerSpend'
                                    onClick={handleCloseApolice}>
                                    <IoMdClose className="closeIconOffcanvasApolicerSpend" />
                                </button>
                            </div>
                            :
                            <>
                                {!!selectOptionsCardNumber ?
                                    <div className='hTextApolice'>{selectOptionsCardNumber}</div>
                                    :
                                    <div className='hTextApolice'>Escolha um seguro</div>
                                }
                                <div className='btnDetail'>
                                    <CustomButton
                                        text={'Ver detalhes'}
                                        textColor={'#141414'}
                                        hasSubLine
                                        hasSubLineSmall
                                        hasSubLineSmallColor={'#141414'}
                                        fontSize={'14px'}
                                        enabled={isCardNumber}
                                        onPress={handleShoweApolice}
                                    />
                                </div>
                            </>
                        }
                    </div>
                    {showApolice &&
                        (selectOptionsReceiptNumber != '' ?
                            (
                                <div className='mainContainerOffcanvasApolicerSpend'>
                                    <div className='infoViewPolicyOffcanvasApolicerSpend'>
                                        <div className='hPrice'>{`€ ${selectedOptionsAmount}`}</div>
                                        <div className='dataPriceMobile'>
                                            <span className='dataPriceBoldMobile'>Data de pagamento </span>
                                            <span className='dataPriceMobile'>{moment(selectedOptionsDate).format('YYYY-MM-DD')}</span>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div className='mainContainerOffcanvasApolicerSpend'>
                                    <div className='infoViewPolicyOffcanvasApolicerSpend'>
                                        <div className='txtDescViewDeductions'>
                                            <span className='txtDescViewDeductions'>Se pagar o seu seguro Médis trimestral, semestral ou anualmente, esta</span>
                                            <span className='txtDescBoldViewDeductions'> opção só fica disponível 45 dias antes da data de pagamento do seguro.</span>
                                        </div>
                                    </div>
                                </div>
                            ))
                    }
                </div>
            )}

            <div className={isTablet ? 'secondMainContainerSpend' : (isMobile ? 'secondMainContainerSpendTablet' : 'secondMainContainerSpendMobile')}>

                {isStartingLoadingAnim ? (
                    <GifAnim hasBg={false} />
                ) : (
                    <>
                        {(selectOptionsList.length > 0 && !hasEmptyReceiptNumber) ? (
                            <>

                                <div className={isTablet ? 'leftContainer' : (isMobile ? 'leftContainerTablet' : 'leftContainerMobile')}>
                                    <div className="policy">
                                        <div className={isTablet ? 'textSecondTitleViewDeductions' : (isMobile ? 'textSecondTitleViewDeductionsTablet' : 'textSecondTitleViewDeductionsMobile')}>Que seguro quer escolher?</div>
                                        <div className='policySubView'>
                                            <div className={isTablet ? 'txtDesctopDescDeductions' : 'txtDescViewDeductions'}>A transferência de saldo da Carteira para um IBAN só é aplicável a seguros Médis individuais, excluem-se os seguros através de empresas.</div>
                                            <div className={isTablet ? 'textWrapperSpendInsurance' : 'textWrapperSpendInsuranceMobile'}>
                                                {/* { selectOptionsCardNumber.length > 0 &&
                                                    (selectOptionsCardNumber.length > 0 && !inputFocus && selectedOption)  ?
                                                        <label className={ isTablet ? 'labelfocusSpendInsurance' : ( isMobile ? 'labelfocusSpendInsurance' : 'labelfocusSpendInsuranceMobile')}></label>
                                                    :
                                                        <label className={ isTablet ? 'labelfocusSpendInsurance' : ( isMobile ? 'labelfocusSpendInsurance' : 'labelfocusSpendInsuranceMobile')}>Escolha entre as opções disponíveis</label>
                                                } */}
                                                <input
                                                    className={isTablet ? 'inputTextSpendInsurance' : (isMobile ? 'inputTextSpendInsurance' : 'inputTextSpendInsuranceMobile')}
                                                    type="text"
                                                    placeholder='Escolha entre as opções disponíveis'
                                                    value={(selectedOption && !inputFocus) ? `Cartão Médis ${selectOptionsCardNumber}` : selectOptionsCardNumber}
                                                    onFocus={handleFocus}
                                                    onBlur={handleBlur}
                                                    // onKeyDown={handleKeyDown}
                                                    onChange={handleInputSeacrhForApolice}

                                                />
                                                <div className={isTablet ? 'findIconViewModalSpendInsurancet' : (isMobile ? 'findIconViewModalSpendInsurancet' : 'findIconViewModalSpendInsurancetMobile')} onClick={handleDropDown}><IoIosArrowDown className='findIconModalSpendInsurancet' /></div>
                                            </div>

                                            {(inputFocus && filteredApolices.length >= 1) && (
                                                <div className={filteredApolices.length > 3 ? 'textWrapperCollumnModalSpendInsurancetSpend' : 'textWrapperSmallViewCollumnSpendInsurancetSpend'} style={{ marginTop: '-16px' }}>
                                                    <div className={filteredApolices.length > 1 ? 'textWrapperCollumnViewSpendInsurancetSpend' : 'textWrapperNoScrollCollumnSpendInsurancetSpend'}>
                                                        {filteredApolices?.map((item, index) => (
                                                            <div key={index} className="searchPosCodListViewModalSpendInsurancet">
                                                                <button className='txtSelectPlaceBtnModalSpendInsurancetSpend' onClick={() => handleSeacrhReason(item)}>
                                                                    {highlightMatchedText(item.cardNumber, selectOptionsCardNumber)}
                                                                </button>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className='deduction'>
                                        <div className={isTablet ? 'textSecondTitleViewDeductions' : (isMobile ? 'textSecondTitleViewDeductionsTablet' : 'textSecondTitleViewDeductionsMobile')}>Quanto quer receber?</div>
                                        <div className='deductionSunView'>
                                            <div className={isTablet ? 'txtDesctopDescDeductions' : 'txtDescViewDeductions'}>Decida o valor que quer que a Médis transfira para a sua conta bancária. O saldo que pode receber é, no máximo, o valor que vai pagar pelo seguro.</div>
                                            <div className='deductionValueViewContainer'>
                                                <div className={deductionValueContainer}>
                                                    <button type="button" onClick={tiraValor} className={(isCardNumber && selectOptionsReceiptNumber != '' && parseFloat(isSaldoCarteira.replace(',', '.')) > 0) ? "btnEsq" : "btnEsqDisable"} disabled={selectOptionsReceiptNumber == '' || parseFloat(isSaldoCarteira.replace(',', '.')) <= 0}>
                                                        <img src={IconMinusSvg} alt='icon' className='iconMath' />
                                                    </button>
                                                    <input
                                                        className='deductionAmount'
                                                        type="text"
                                                        placeholder="0,00"
                                                        value={inputAmountFocus ? `${value}` : `${value} €`}
                                                        onFocus={handleFocusAmount}
                                                        onBlur={handleBlurAmount}
                                                        onChange={handleAmountChange}
                                                        disabled={selectOptionsReceiptNumber == '' || parseFloat(isSaldoCarteira.replace(',', '.')) <= 0}

                                                    />
                                                    <button type="button" onClick={meteValor} className={(isCardNumber && selectOptionsReceiptNumber != '' && parseFloat(isSaldoCarteira.replace(',', '.')) > 0) ? "btnDir" : "btnDirDisable"} disabled={selectOptionsReceiptNumber == '' || parseFloat(isSaldoCarteira.replace(',', '.')) <= 0}>
                                                        <img src={IconPlusSvg} alt='icon' className='iconMath' />
                                                    </button>
                                                </div>
                                                {(errorMsgValue !== '') &&
                                                    <div className='txtViewErrorInfoSpendInsurance'>
                                                        <div className='txtErrorInfoSpendInsurance'><AiOutlineStop className='iconErrorInfoSpendInsurance' /> {errorMsgValue}</div>
                                                    </div>
                                                }
                                            </div>
                                            <div className="quick-values">
                                                <button
                                                    type="button"
                                                    onClick={setQuickValue5}
                                                    className={
                                                        (selectOptionsReceiptNumber !== '' && parseFloat(isSaldoCarteira.replace(',', '.')) > 0)
                                                            ?
                                                            (isSelectedValue5 ? "quick-value focus" : "quick-value")
                                                            : "quick-valueDisable"
                                                    }
                                                    disabled={selectOptionsReceiptNumber == '' || parseFloat(isSaldoCarteira.replace(',', '.')) <= 0}
                                                >5€</button>
                                                <button
                                                    type="button"
                                                    onClick={setQuickValue10}
                                                    className={
                                                        (selectOptionsReceiptNumber !== '' && parseFloat(isSaldoCarteira.replace(',', '.')) > 0)
                                                            ?
                                                            (isSelectedValue10 ? "quick-value focus" : "quick-value")
                                                            : "quick-valueDisable"
                                                    }
                                                    disabled={selectOptionsReceiptNumber == '' || parseFloat(isSaldoCarteira.replace(',', '.')) <= 0}
                                                >10€</button>
                                                <button
                                                    type="button"
                                                    onClick={setQuickValue20}
                                                    className={
                                                        (selectOptionsReceiptNumber !== '' && parseFloat(isSaldoCarteira.replace(',', '.')) > 0)
                                                            ?
                                                            (isSelectedValue20 ? "quick-value focus" : "quick-value")
                                                            : "quick-valueDisable"
                                                    }
                                                    disabled={selectOptionsReceiptNumber == '' || parseFloat(isSaldoCarteira.replace(',', '.')) <= 0}
                                                >20€</button>
                                            </div>
                                        </div>
                                    </div>

                                    <div className={isTablet ? 'textFormViewSpendInsurance' : 'textFormViewSpendInsuranceMobile'}>
                                        <div className={isTablet ? 'textSecondTitleViewDeductions' : (isMobile ? 'textSecondTitleViewDeductionsTablet' : 'textSecondTitleViewDeductionsMobile')}>Em que IBAN quer receber o saldo?</div>
                                        <div className={isTablet ? 'textWrapperSpendInsurance' : 'textWrapperSpendInsuranceMobile'}>
                                            {iban.length > 0 &&
                                                <label className={isTablet ? 'labelfocusSpendInsurance' : (isMobile ? 'labelfocusSpendInsurance' : 'labelfocusSpendInsuranceMobile')}>Escreva o IBAN para onde será transferido o saldo</label>
                                            }
                                            <input
                                                className={`${isTablet ? 'inputTextSpendInsurance' : (isMobile ? 'inputTextSpendInsurance' : 'inputTextSpendInsuranceMobile')} ${errorMsgIban !== '' ? 'error' : ''}`}
                                                type="text"
                                                placeholder="PT50"
                                                value={iban}
                                                onChange={handleIbanChange}
                                                maxLength={31}
                                                checked={errorMsgIban !== ''}

                                            />
                                            {(errorMsgIban !== '') &&
                                                <div className='txtViewErrorInfoSpendInsurance'>
                                                    <div className='txtErrorInfoSpendInsurance'><AiOutlineStop className='iconErrorInfoSpendInsurance' /> {errorMsgIban}</div>
                                                </div>
                                            }
                                        </div>
                                    </div>

                                    <div className='btnStartDeducao'>
                                        <CustomButton
                                            text={'Transferir saldo'}
                                            textColor={'#00214D'}
                                            onPress={postValidatePremiumDeduction}
                                            enabled={
                                                (isCardNumber &&
                                                    iban.length === 31 &&
                                                    selectOptionsReceiptNumber != '' &&
                                                    parseFloat(value.replace(',', '.')) > 0 &&
                                                    isStatusCarteira !== '0' &&
                                                    parseFloat(isSaldoCarteira.replace(',', '.')) > 0
                                                )}
                                            color={'#15D4B6'}
                                            hasArrow
                                            iconColor={'#00214D'}
                                            loading={isStartingLoadingDots}
                                        />
                                    </div>
                                </div>

                                {isTablet ?
                                    <div className='rigthContent'>
                                        <div className="wrapper">
                                            <div className='glass'>
                                                {isCardNumber ?
                                                    <>
                                                        <div className='policyHCardNumber'>O seu próximo recibo</div>
                                                        <div className='policyTextCardNumberViewContainer'>
                                                            <div className='policyTextCardNumber'>O seu seguro</div>
                                                            <div className='cardNumber'>{selectOptionsCardNumber}</div>
                                                        </div>
                                                    </>
                                                    :
                                                    <>
                                                        <div className='policyH'>O seu seguro</div>
                                                        <div className='policyTextCardNumberViewContainer'>
                                                            <div className='policyText'>Escolha um seguro Médis individual</div>
                                                        </div>
                                                    </>
                                                }
                                            </div>
                                            {isCardNumber ?
                                                (selectOptionsReceiptNumber != '' ? (
                                                    <div className='price'>
                                                        <div className='hPrice'>{`€ ${selectedOptionsAmount}`}<span className='hPriceS'></span></div>
                                                        <div className='dataPrice'>{`Data de pagamento ${moment(selectedOptionsDate).format('YYYY-MM-DD')}`}</div>
                                                    </div>
                                                ) : (
                                                    <div className='price'>
                                                        <div className='txtDescViewDeductions'>
                                                            <span className='txtDescViewDeductions'>Se pagar o seu seguro Médis trimestral, semestral ou anualmente, esta</span>
                                                            <span className='txtDescBoldViewDeductions'> opção só fica disponível 45 dias antes da data de pagamento do seguro.</span>
                                                        </div>
                                                    </div>
                                                ))
                                                :
                                                <div></div>
                                            }

                                        </div>
                                    </div>
                                    :
                                    (isMobile ? null : null)
                                }
                            </>
                        ) : (
                            <EmptyInsuranceList />
                        )
                        }
                    </>
                )}
            </div >
            {(selectOptionsList.length > 0 && !hasEmptyReceiptNumber) && (
                isDeduction ?
                    <div className={isTablet ? 'plannedDeductions' : (isMobile ? 'plannedDeductionsTablet' : 'plannedDeductionsMobile')}>
                        <div className='titlePlannedDeductions'>
                            <div className='noPlanH'>Transferências planeadas</div>
                            <div className='policyHView'>
                                <div className='noPlanP'>Acompanhe as transferências de saldo Carteira Virtual para a sua conta bancária. </div>
                                <div className='noPlanP'>Pode demorar até 15 dias úteis a receber o montante.</div>
                            </div>
                            {isRefreshConsultaDeducoes ?
                                <GifAnim />
                                :
                                <ListDeduction
                                    listRespData={deducoesList}
                                    numPage={numeroDePaginas}
                                    pageNumber={pageNumber}
                                    setPageSelected={setPageNumber}
                                />
                            }
                        </div>
                    </div>
                    :
                    <div className={isTablet ? 'plannedDeductions' : (isMobile ? 'plannedDeductionsTablet' : 'plannedDeductionsMobile')}>
                        <div className='titlePlanned'>
                            <div className='noPlanH'>Sem transferências planeadas</div>
                            <div className='noPlanPViewContainer'>
                                <div className='noPlanP'>Pode demorar até 15 dias úteis a receber o montante na sua conta bancária.</div>
                                <div className='noPlanP'>
                                    <span className='noPlanP'>Continue a fazer compras em </span>
                                    <span className='noPlanPSublineClick' onClick={hadleBtnBoxGoPartnersList}>parceiros da Carteira Virtual</span>
                                    <span className='noPlanP'> para acumular saldo.</span>
                                </div>
                            </div>
                        </div>
                    </div>
            )}

            {/* Start bottom div componet with info steps */}
            <div className={isTablet ? 'mainBottomViewContainerDeductionsInfoSlider' : (isMobile ? 'mainBottomViewContainerDeductionsInfoSliderTablet' : 'mainBottomViewContainerDeductionsInfoSliderMobile')}>
                <div className={isTablet ? 'titileViewForBottomViewContainerDeductionsInfoSlider' : (isMobile ? 'titileViewForBottomViewContainerDeductionsInfoSliderTablet' : 'titileViewForBottomViewContainerDeductionsInfoSliderMobile')}>
                    <div className={isTablet ? 'textTitleBoldDeductionsInfoSliderWithSaldo' : 'textTitleRegularDeductionsInfoSliderWithSaldoMobile'}>Como funciona?</div>
                    <div className='noPlanPViewContainer'>
                        <div className='txtPartnerContactInfoBlakDeductionsInfoSlider'>Pode transferir o saldo que tem na Carteira Virtual para a sua conta bancária.</div>
                        <div className='txtPartnerContactInfoBlakDeductionsInfoSlider'>
                            <span className='txtPartnerContactInfoBlakDeductionsInfoSlider'>Só é válido para contas Minha Médis com pelo menos um </span>
                            <span className='noPlanPSublineClick' onClick={hadleBtnBoxGoAssociatedInsurance}>seguro Médis associado</span>
                            <span className='txtPartnerContactInfoBlakDeductionsInfoSlider'>.</span>
                        </div>
                    </div>
                </div>

                <div className={isTablet ? 'secondSliderAdsContainerDeductionsInfoSlider' : (isMobile ? 'secondSliderAdsContainerDeductionsInfoSliderTablet' : 'secondSliderAdsContainerDeductionsInfoSliderMobile')}>
                    <Swiper
                        onSlideChange={(swiperOne) => handleSwiperSlideChangeOne(swiperOne)}
                        onSwiper={(swiperOne) => setSwiperInstanceOne(swiperOne)}
                        slidesPerView={isTablet ? 3 : 1}
                        spaceBetween={32}
                        // pagination={{
                        //     clickable: true,
                        //   }}
                        modules={[Pagination]}
                        className={isTablet ? "mySwiperBoxViewContainerDeductionsInfoSlider" : (isMobile ? "mySwiperBoxViewContainerDeductionsInfoSliderTablet" : "mySwiperBoxViewContainerDeductionsInfoSliderMobile")}
                    >
                        <SwiperSlide>
                            <div onClick={hadleBtnBoxGoAssociatedInsurance} className={isTablet ? 'boxViewContainerBottomViewContainerDeductionsInfoSlider' : (isMobile ? 'boxViewContainerBottomViewContainerDeductionsInfoSliderTablet' : 'boxViewContainerBottomViewContainerDeductionsInfoSliderMobile')}>
                                <img src={IconAddCard} alt="imagem" className="iconPartnerLogoSvgDeductionsInfoSlider" />
                                <div className='titleContainerDeductionsInfoSliderWithSaldo'>
                                    <div className='txtTitleBoldAdsOfferDeductionsInfoSliderView'>
                                        <div className='txtTitleBoldAdsOfferDeductionsInfoSlider'>1.</div>
                                        <div className='txtTitleBoldAdsOfferDeductionsInfoSlider'> Confirme se pode receber o saldo na sua conta</div>
                                    </div>
                                    <div className='txtPartnerInfoDeductionsInfoSliderView'>
                                        <div className='txtPartnerInfoDeductionsInfoSlider'>Esta opção só está disponível:</div>
                                        <div className='txtTitleBoldAdsOfferDeductionsInfoSliderView'>
                                            <div className='txtPartnerInfoDeductionsInfoSlider'></div>
                                            <div className='txtPartnerInfoDeductionsInfoSlider'>&#x2022;</div>
                                            <div className='txtPartnerInfoDeductionsInfoSlider'>
                                                <span className='txtPartnerInfoDeductionsInfoSlider'>para contas com</span>
                                                <span className='txtBoldPartnerInfoDeductionsInfoSlider'> seguro Médis associado</span>
                                            </div>
                                        </div>
                                        <div className='txtTitleBoldAdsOfferDeductionsInfoSliderView'>
                                            <div className='txtPartnerInfoDeductionsInfoSlider'></div>
                                            <div className='txtPartnerInfoDeductionsInfoSlider'>&#x2022;</div>
                                            <div className='txtPartnerInfoDeductionsInfoSlider'>
                                                <span className='txtPartnerInfoDeductionsInfoSlider'> para</span>
                                                <span className='txtBoldPartnerInfoDeductionsInfoSlider'> seguro Médis individual</span>
                                                <span className='txtPartnerInfoDeductionsInfoSlider'> &#x28;saúde ou dentário&#x29;</span>
                                            </div>
                                        </div>
                                        <div className='txtPartnerContactDataDeductionsInfoSlider'>Já associou o seguro à conta Minha Médis?</div>
                                    </div>
                                </div>
                                {/* <div className='arrowBtnViewPartnerContactDataDeductionsInfoSlider'>
                                        <div className='txtArrowBtnPartnerContactDataDeductionsInfoSlider'>
                                            <img src={ImgArrowRight} alt='icon' className='iconBtnInfoNavBoxDeductionsInfoSlider' />
                                        </div>
                                    </div> */}
                            </div>
                            {isTablet ? (
                                null
                            ) : isMobile ? (
                                <>
                                    <div className='boxMainShadowFirstViewContainerBottomViewContainerDeductionsInfoSliderTablet'>
                                        <div className='boxShadowFirstViewContainerBottomViewContainerDeductionsInfoSliderTablet'></div>
                                    </div>
                                    <div className='boxMainShadowFirstViewContainerBottomViewContainerDeductionsInfoSliderTablet'>
                                        <div className='boxShadowSecondViewContainerBottomViewContainerDeductionsInfoSliderTablet'></div>
                                    </div>
                                </>
                            ) : (
                                null
                            )
                            }
                        </SwiperSlide>

                        <SwiperSlide>
                            <div className={isTablet ? 'boxViewContainerBottomViewContainerDeductionsInfoSlider' : (isMobile ? 'boxViewContainerBottomViewContainerDeductionsInfoSliderTablet' : 'boxViewContainerBottomViewContainerDeductionsInfoSliderMobile')}>
                                <img src={IconGetPercentage} alt="imagem" className="iconPartnerLogoSvgDeductionsInfoSlider" />
                                <div className='titleContainerDeductionsInfoSliderWithSaldo'>
                                    <div className='txtTitleBoldAdsOfferDeductionsInfoSliderView'>
                                        <div className='txtTitleBoldAdsOfferDeductionsInfoSlider'>2.</div>
                                        <div className='txtTitleBoldAdsOfferDeductionsInfoSlider'> Só pode transferir saldo perto do pagamento do seguro</div>
                                    </div>
                                    <div className='txtPartnerInfoDeductionsInfoSliderView'>
                                        <div className='txtPartnerInfoDeductionsInfoSlider'>A data de pagamento do seu seguro determina quando pode transferir saldo:</div>
                                        <div className='txtTitleBoldAdsOfferDeductionsInfoSliderView'>
                                            <div className='txtPartnerInfoDeductionsInfoSlider'></div>
                                            <div className='txtPartnerInfoDeductionsInfoSlider'>&#x2022;</div>
                                            <div className='txtPartnerInfoDeductionsInfoSlider'>
                                                <span className='txtBoldPartnerInfoDeductionsInfoSlider'>Mensal:</span>
                                                <span className='txtPartnerInfoDeductionsInfoSlider'> sempre disponível</span>
                                            </div>
                                        </div>
                                        <div className='txtTitleBoldAdsOfferDeductionsInfoSliderView'>
                                            <div className='txtPartnerInfoDeductionsInfoSlider'></div>
                                            <div className='txtPartnerInfoDeductionsInfoSlider'>&#x2022;</div>
                                            <div className='txtPartnerInfoDeductionsInfoSlider'>
                                                <span className='txtBoldPartnerInfoDeductionsInfoSlider'>Trimestral, semestral ou anual:</span>
                                                <span className='txtPartnerInfoDeductionsInfoSlider'> disponível 45 dias antes do pagamento do seguro.</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className='arrowBtnViewPartnerContactDataDeductionsInfoSlider'>
                                        <div className='txtArrowBtnPartnerContactDataDeductionsInfoSlider'>
                                            <img src={ImgArrowRight} alt='icon' className='iconBtnInfoNavBoxDeductionsInfoSlider' />
                                        </div>                                    
                                    </div> */}
                            </div>
                            {isTablet ? (
                                null
                            ) : isMobile ? (
                                <>
                                    <div className='boxMainShadowFirstViewContainerBottomViewContainerDeductionsInfoSliderTablet'>
                                        <div className='boxShadowFirstViewContainerBottomViewContainerDeductionsInfoSliderTablet'></div>
                                    </div>
                                    <div className='boxMainShadowFirstViewContainerBottomViewContainerDeductionsInfoSliderTablet'>
                                        <div className='boxShadowSecondViewContainerBottomViewContainerDeductionsInfoSliderTablet'></div>
                                    </div>
                                </>
                            ) : (
                                null
                            )
                            }
                        </SwiperSlide>

                        <SwiperSlide>
                            <div className={isTablet ? 'boxViewContainerBottomViewContainerDeductionsInfoSlider' : (isMobile ? 'boxViewContainerBottomViewContainerDeductionsInfoSliderTablet' : 'boxViewContainerBottomViewContainerDeductionsInfoSliderMobile')}>
                                <img src={IconSpendBalance} alt="imagem" className="iconPartnerLogoSvgDeductionsInfoSlider" />
                                <div className='titleContainerDeductionsInfoSliderWithSaldo'>
                                    <div className='txtTitleBoldAdsOfferDeductionsInfoSliderView'>
                                        <div className='txtTitleBoldAdsOfferDeductionsInfoSlider'>3.</div>
                                        <div className='txtTitleBoldAdsOfferDeductionsInfoSlider'> A transferência acontece após o pagamento do seguro</div>
                                    </div>
                                    <div className='txtTitleBoldAdsOfferDeductionsInfoSliderView'>
                                        <div className='txtPartnerInfoDeductionsInfoSlider'>
                                            <span className='txtPartnerInfoDeductionsInfoSlider'>A</span>
                                            <span className='txtBoldPartnerInfoDeductionsInfoSlider'> transferência de saldo é feita apenas após a boa cobrança do recibo do seguro</span>
                                            <span className='txtPartnerInfoDeductionsInfoSlider'> e pode demorar até cerca de 15 dias úteis a chegar à sua conta bancária.</span>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className='arrowBtnViewPartnerContactDataDeductionsInfoSlider'>
                                        <div className='txtArrowBtnPartnerContactDataDeductionsInfoSlider'>
                                            <img src={ImgArrowRight} alt='icon' className='iconBtnInfoNavBoxDeductionsInfoSlider' />
                                        </div>                                    
                                    </div> */}
                            </div>
                            {isTablet ? (
                                null
                            ) : isMobile ? (
                                <>
                                    <div className='boxMainShadowFirstViewContainerBottomViewContainerDeductionsInfoSliderTablet'>
                                        <div className='boxShadowFirstViewContainerBottomViewContainerDeductionsInfoSliderTablet'></div>
                                    </div>
                                    <div className='boxMainShadowFirstViewContainerBottomViewContainerDeductionsInfoSliderTablet'>
                                        <div className='boxShadowSecondViewContainerBottomViewContainerDeductionsInfoSliderTablet'></div>
                                    </div>
                                </>
                            ) : (
                                null
                            )
                            }
                        </SwiperSlide>
                    </Swiper>
                </div>

                {!isTablet &&
                    <div className={isTablet ? 'thirdSubMainContainerCircleNavDeductionsInfoSlider' : 'thirdSubMainContainerDeductionsInfoSliderMobile'}>
                        <button className='iconArrowLeftViewContainerCircleNavDeductionsInfoSlider' onClick={prevImageOne} disabled={swiperIndexOne == 0}>
                            <FaArrowLeftLong className='iconArrowCircleNavDeductionsInfoSlider' />
                        </button>

                        <div className='cirlceSelectedNavDeductionsInfoSlider'>
                            {isTablet ?
                                <div className='circleMainvViewNavDeductionsInfoSlider'>
                                    <div className='circleContainerNavDeductionsInfoSlider'>
                                        <div className={swiperIndexOne == 0 ? 'circleSelectedViewNavDeductionsInfoSlider' : 'circleViewNavDeductionsInfoSlider'} />
                                    </div>
                                    <div className='circleContainerNavDeductionsInfoSlider'>
                                        <div className={swiperIndexOne == 1 ? 'circleSelectedViewNavDeductionsInfoSlider' : 'circleViewNavDeductionsInfoSlider'} />
                                    </div>
                                </div>
                                :
                                <div className='circleMainvViewNavDeductionsInfoSlider'>
                                    <div className='circleContainerNavDeductionsInfoSlider'>
                                        <div className={swiperIndexOne == 0 ? 'circleSelectedViewNavDeductionsInfoSlider' : 'circleViewNavDeductionsInfoSlider'} />
                                    </div>
                                    <div className='circleContainerNavDeductionsInfoSlider'>
                                        <div className={swiperIndexOne == 1 ? 'circleSelectedViewNavDeductionsInfoSlider' : 'circleViewNavDeductionsInfoSlider'} />
                                    </div>
                                    <div className='circleContainerNavDeductionsInfoSlider'>
                                        <div className={swiperIndexOne == 2 ? 'circleSelectedViewNavDeductionsInfoSlider' : 'circleViewNavDeductionsInfoSlider'} />
                                    </div>
                                </div>
                            }
                        </div>

                        <button className='iconArrowRightViewContainerCircleNavDeductionsInfoSlider' onClick={nextImageOne} disabled={isTablet ? swiperIndexOne === 1 : swiperIndexOne >= 2}>
                            <FaArrowRightLong className='iconArrowCircleNavDeductionsInfoSlider' />
                        </button>
                    </div>
                }
                <div className='faqBtnDeductionsInfo'>
                    <CustomButton
                        text={'Ver mais Perguntas Frequentes'}
                        textColor={'#141414'}
                        borderColor={'#141414'}
                        onPress={hadleBtnBoxGoFAQ}
                        hasShadow={false}
                    />
                </div>
            </div>
            {/* End bottom div componet with info steps */}

        </>
    )
}

export default SpendInsurance